module.exports = __webpack_public_path__ + "img/docx.41b9fabc.png";